import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', (date) => {
  return moment(date).format('ddd. MMM DD YYYY, h:mm a')
})

Vue.filter('timeAgo', (date) => {
  return moment(date).fromNow()
})

Vue.filter('time', (date) => {
  return moment(date).format('h:mm:ss a')
})

Vue.filter('uppercase', (word) => {
  return word.toUpperCase()
})
